import { IConfig } from '@cian/config/shared';
import { ContentDataType, FetchModelResponse, IFetchModel } from '@cian/http-api';

export function withJobName<
  TRequest,
  TResponse extends FetchModelResponse<number, ContentDataType | undefined, unknown>,
  TModel extends IFetchModel<TRequest, 'json', TResponse>,
>(config: IConfig, model: TModel): TModel {
  const jobName = config.get<string>(`${model.microserviceName}.jobName`);
  if (!jobName) {
    return model;
  }

  return {
    ...model,
    microserviceName: `${model.microserviceName}-${jobName}`,
  } as TModel;
}
